import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

export function useSiteContent() {
  const [content, setContent] = useState(cache);

  useEffect(() => {
    if (!cache) {
      api.get("/site-content").then((r) => {
        cache = r.data;
        setContent(r.data);
        listeners.forEach((fn) => fn(r.data));
      }).catch(() => {});
    }
    const fn = (c) => setContent(c);
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  }, []);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/site-content");
    cache = data;
    listeners.forEach((fn) => fn(data));
  }, []);

  return { content: content || {}, refresh };
}
